import { DateTime } from "@/@client/System"
import dayjs from "dayjs"

export function getDurationFormatted(
  start?: Date | DateTime | string,
  end?: Date | DateTime | string
): string {
  if (!start || !end) return ""
  const diff = dayjs(end).diff(dayjs(start), "minute")
  const hours = Math.floor(diff / 60)
  const minutes = diff % 60
  return `${hours} h ${String(minutes).padStart(2, "0")} m`
}
